export default __webpack_public_path__ + "static/media/value-innovate.9c191bab.svg";